import { render, staticRenderFns } from "./ViewerCount.vue?vue&type=template&id=3429420e"
import script from "./ViewerCount.vue?vue&type=script&lang=js"
export * from "./ViewerCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports